var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"display":"flex","margin-top":"40px","justify-content":"space-between","font-weight":"bold"}},[_c('div',[_vm._v(_vm._s(_vm.$t('mlModel.SetpointOptimizer.averageDescription')))]),_c('div',[_vm._v(" "+_vm._s(_vm.averageOfRoomTemps)+" °C ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }